import React,{ useState, useEffect,useRef,useCallback, useMemo ,useContext} from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { deleteUser, getAllUsers,createUser,editUser,getOneUser, blockUser, changePassword } from '../../api/axiosUsers';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { Password } from 'primereact/password';
import { InputSwitch } from "primereact/inputswitch";
import NameAvatar from '../../components/avatars/NameAvatar';
import { Dropdown } from 'primereact/dropdown';
import { getAllRoles } from '../../api/axiosRoles';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';
import { Panel } from 'primereact/panel';
import { getAllRegions } from '../../api/axiosRegions';
import { getRegionDistricts } from '../../api/axiosDistricts';
import { Paginator } from 'primereact/paginator';
import { Skeleton } from 'primereact/skeleton';









const Users = () => {
  const { users, setUsers, roles, setRoles, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const navigate = useNavigate()


  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [regions, setRegions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [errors, setErrors] = useState({})
  const [emailInvalid, setEmailInvalid] = useState("");
  const [passwordInvalid, setPasswordInvalid] = useState("");

  const [changePasswordDialogVisible, setChangePasswordDialogVisible] = useState(false);
  
  
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Updating

  //Creating User
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [tin, setTin] = useState("");
  const [selectedSex, setSelectedSex] = useState("");
  const [phone, setPhone] = useState("");
  

  //Editing User
  const [editedFirstName, setEditedFirstName] = useState("");
  const [editedLastName, setEditedLastName] = useState("");
  const [editedEmail, setEditedEmail] = useState("");
  const [editedPassword,setEditedPassword] = useState("");
  const [editedSelectedRole, setEditedSelectedRole] = useState("");
  const [editedSelectedRegion, setEditedSelectedRegion] = useState("");
  const [editedSelectedDistrict, setEditedSelectedDistrict] = useState("");
  const [editedTin, setEditedTin] = useState("");
  const [editedSelectedSex, setEditedSelectedSex] = useState("");
  const [editedPhone, setEditedPhone] = useState("");
  const [editDistricts, setEditDistricts] = useState([]);
  const [districtNameToSelect, setDistrictNameToSelect] = useState("");

  const [searchTerm, setSearchTerm] = useState("");





  const NewTitle = "All Users";
  useEffect(() => {
    
    getAllUsers(
      setIsLoading,
      setFirst,
      setRows,
      undefined,
      setUsers,
      setTotalCount,
      setFetcherror,
      searchTerm
    )
    getAllRoles(setRoles, setFetcherror);
    getAllRegions(setRegions, setFetcherror);


    
  }, []);

  //  Debounce Function and Search Function
  
  
  const handleInputChangeDBSearch = (value) => setSearchTerm(value);
  
  useEffect(() => {
    const id = setTimeout(() => {
      getAllUsers(
        setIsLoading, setFirst, setRows,
        undefined, setUsers, setTotalCount,
        setFetcherror, searchTerm
      );
    }, 1000);
    return () => clearTimeout(id);
  }, [searchTerm]);



  const reversedUsers = React.useMemo(
    () => [...users].reverse(),
    [users]
  );

  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setUsers, setFetcherror, handleAllToasts) => {
    return () => {
      deleteUser(pkid, setUsers, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this User?, Click "Yes" to Proceed or "No" to Cancel</p>
  );


  useEffect(() => {
    if (editedSelectedRegion?.id) {
      getRegionDistricts((fetchedDistricts) => {
        setDistricts(fetchedDistricts);
        if (districtNameToSelect) {
          const obtainedDistrict = fetchedDistricts.find((item) => item.name === districtNameToSelect);
          setEditedSelectedDistrict(obtainedDistrict);
          setDistrictNameToSelect(null); // Clear the temporary district name after setting it
        }
      }, setFetcherror, editedSelectedRegion.id);
    }
  }, [editedSelectedRegion, districtNameToSelect]);


  const getItemtoEdit = (rowData) => {
    setEditedFirstName(rowData?.firstname);
    setEditedLastName(rowData?.lastname);
    setEditedPhone(rowData?.phone);
    setEditedTin(rowData?.tin);

    const obtainedrole = roles.find((item) => item.name === rowData.role);
    setEditedSelectedRole(obtainedrole);
    
    const obtainedregion = regions.find((item) => item.name === rowData.region);
    setEditedSelectedRegion(obtainedregion);

    const obtainedsex = [{ id: 1, name: "MALE" }, { id: 2, name: "FEMALE" }].find((item) => item.name === rowData.sex);
    setEditedSelectedSex(obtainedsex);

    setDistrictNameToSelect(rowData.district);
  

};

 
  
  
  const checkInvalidInput = () => { 

    if (!email) setEmailInvalid("p-invalid");
    if (!password) setPasswordInvalid("p-invalid");
  }

  const emailClass = `w-full mb-3 pr-5 loginformField ${emailInvalid}`
  const passwordClass=`'w-full mb-0 loginformField' ${passwordInvalid}`

  const randomColors = {};
   useEffect(() => {
    users.forEach((user) => {
    randomColors[user.id] = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    });
   }, [users])
  
  
   const limitOptions = [5, 10, 20, 30, 50, 100, 200, 500];
  const skeletonitems = Array.from({ length: 5 }, (v, i) => i);
  
  const onPageChange = (event) => {
    getAllUsers(
      setIsLoading,
      setFirst,
      setRows,
      event,
      setUsers,
      setTotalCount,
      setFetcherror
    )
}
  
 

  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
      <SearchToolBar
          setAddItemDialogVisible={setAddItemDialogVisible}
          globalFilter={searchTerm}
          setGlobalFilter={setSearchTerm}
          searchPlaceholder="Users"
          createLabel="User"
          handleInputChangeDBSearch={handleInputChangeDBSearch}
        />
        
        {!isLoading && <DataTable
          value={reversedUsers}
          showGridlines
          emptyMessage="No users found"
         
        >
                    
          <Column header="Name" body={(rowData) => (<span><NameAvatar name={rowData.firstname} bgcolor={randomColors[rowData.id]} />  {rowData.firstname} {rowData.lastname}</span>)} sortable></Column>
          <Column header="Email" body={(rowData) => rowData.email} sortable></Column>
          <Column header="Roles" body={(rowData) => (
            <div className='flex flex-row'>
              {rowData.role === "Admin" && <div className='m-1'><Tag severity="danger" value="Admin"></Tag></div>}
              {rowData.role === "Operator" && <div className='m-1'><Tag severity="warning" value="Operator"></Tag></div>}
              {rowData.role === "ZNLeader" && <div className='m-1'><Tag severity="help" value="ZNLeader"></Tag></div>}
              {rowData.role === "Monitor" && <div className='m-1'><Tag severity="info" value="Monitor"></Tag></div>}
              {rowData.role === "Citizen" && <div className='m-1'><Tag severity="success" value="Citizen"></Tag></div>}
              {!["Admin", "Operator", "ZNLeader", "Monitor", "Citizen"].includes(rowData.role) && <div className='m-1'><Tag severity="primary" value={rowData.role}></Tag></div>}
            </div>)} >
                          
          </Column>
          <Column header="Region" body={(rowData) => rowData.region} sortable></Column>
          <Column header="Action" body={(rowData) => (
                            
            <div className='flex flex-row'>
              <Button
                icon="pi pi-user-edit"
                outlined
                // label='Edit'
                severity="success"
                aria-label="Cancel"
                className='px-3 py-1 text-xs mr-2 font-light'
                onClick={() => {
                  getItemtoEdit(rowData);
                  setSelectedId(rowData.id);
                  setEditDialogVisible(true);
                }}
                              
              />
              
              <Button
                icon="pi pi-trash"
                // disabled
                outlined
                // label='Delete'
                severity="danger"
                aria-label="Cancel"
                className='px-3 py-1 text-xs mr-2 font-light'
                onClick={() => {
                  setSelectedId(rowData.id);
                  setDeleteDialogVisible(true);
                }}
                              
              />
              
              <Button
                icon={rowData.blocked ? "pi pi-lock" : "pi pi-lock-open"}
                outlined
                severity={rowData.blocked ? "danger" : "secondary"}
                aria-label="Block"
                className='px-3 py-1 text-xs mr-2 font-light'
                // label={ rowData.isBlocked ? "Unblock" :"Block"}
                onClick={() => {
                  setSelectedId(rowData.id);
                  blockUser (
                    rowData.id,
                    setUsers,
                    setIsLoading,setFirst,setRows,setTotalCount,
                    setFetcherror,
                    handleAllToasts)
                }}
                              
              />
              
              <Button
                icon="pi pi-key"
                // disabled
                outlined
                // label='reset'
                severity="info"
                aria-label="Reset"
                className='px-3 py-1 text-xs'
                onClick={() => {
                  setSelectedId(rowData.id);
                  setChangePasswordDialogVisible(true)
                }}
              />
            </div>
                        
          )}>
          </Column>
        </DataTable>}

        
        {isLoading && 
          
          <DataTable value={skeletonitems} className="p-datatable-striped">
          <Column field="S/N" header="S/N" style={{ width: '10%' }} body={<Skeleton />}sortable></Column>
          <Column field="name" header="Name" style={{ width: '15%' }} body={<Skeleton />}sortable></Column>
          <Column field="email" header="Email" style={{ width: '50%' }} body={<Skeleton />}sortable></Column>
          <Column field="roles" header="Roles" style={{ width: '15%' }} body={<Skeleton />}></Column>
          <Column field="region" header="Region" style={{ width: '10%' }} body={<Skeleton />}></Column>
          <Column field="actions" header="Actions" style={{ width: '10%' }} body={<Skeleton />}></Column>
          </DataTable>
          }

          {!isLoading &&
            <Paginator
              first={first}
              rows={rows}
              totalRecords={totalCount}
              rowsPerPageOptions={limitOptions}
              onPageChange={onPageChange}
            />
          } 

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8'  visible={addItemeDialogVisible} style={{ width: '60vw' }} onHide={() => setAddItemDialogVisible(false)} >
             
              <Panel header="New User">

              <form onSubmit={(e) => { 
                e.preventDefault();
                  createUser(
                    firstName,
                    setFirstName,
                    lastName,
                    setLastName,
                    email,
                    setEmail,
                    password,
                    setPassword,
                    selectedRole,
                    setSelectedRole,
                    phone,
                    setPhone,
                    selectedSex,
                    setSelectedSex,
                    selectedRegion,
                    setSelectedRegion,
                    selectedDistrict,
                    setSelectedDistrict,
                    tin,
                    setTin,
                    setFetcherror,
                    handleAllToasts,
                    setUsers,
                    setIsLoading,
                    setFirst,
                    setRows,
                    undefined,
                    setTotalCount,
                  );
                }}>
                  


                <div className='flex justify-content-between mb-4 w-full'>
                      <div className='w-4 pr-4' >
                        <label htmlFor="First Name" className="block text-900 font-medium mb-2">First Name</label>
                        <InputText
                          className='w-full'
                          type="text"
                          placeholder="Enter First Name"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                      </div>

                      <div className='w-4 px-2'>
                        <label htmlFor="First Name" className="block text-900 font-medium mb-2">Last Name</label>
                        <InputText
                          className='w-full'
                          type="text"
                          placeholder="Enter Last Name"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                        />
                    </div>
                    
                    <div className='w-4 pl-4'>
                      <label htmlFor="sex" className="block text-900 font-medium mb-2">Sex</label>
                      <Dropdown
                        value={selectedSex}
                        onChange={(e) => setSelectedSex(e.value)}
                        options={[{ id: 1, name: "MALE" }, { id: 2, name: "FEMALE" }]} optionLabel="name"
                        placeholder=" Select Sex " showClear className="w-full"
                        
                      /> 
                    </div>
                  </div>
                  
                  
                  <div className='flex justify-content-between mb-4 w-full'>

                      <div className='w-4 pr-4' >
                        <label htmlFor="Email" className="block text-900 font-medium mb-2">Email</label>
                        <InputText
                          className='w-full'
                          type="text"
                          placeholder="Enter Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>

                      <div className='w-4 px-2'>
                        <label htmlFor="password" className="block text-900 font-medium mb-2">Password</label>
                        <Password
                          className={passwordClass}
                          toggleMask
                          feedback={false}
                          placeholder='Enter Password'
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onFocus={() => setPasswordInvalid("")}
                          />
                      </div>

                      <div className='w-4 pl-4'>
                        <label htmlFor="selectedrole" className="block text-900 font-medium mb-2">Role</label>
                          <Dropdown
                          value={selectedRole} onChange={(e) => setSelectedRole(e.value)}
                          options={roles} optionLabel="name"
                          placeholder="-- Select Role --" showClear className="w-full"
                          />
                      </div>
                  </div>
                  
                  <div className='flex justify-content-between mb-4 w-full'>
                
                      <div className='w-4 pr-4' >
                        <label htmlFor="region" className="block text-900 font-medium mb-2">Region</label>
                        <Dropdown
                          value={selectedRegion}
                          onChange={(e) => {
                            setSelectedRegion(e.value);
                            getRegionDistricts(setDistricts, setFetcherror, e.value?.id);
                          }}
                          options={regions}
                          optionLabel="name"
                          placeholder=" Select Region "
                          showClear
                          className="w-full"
                        />
                      </div>

                      <div className='w-4 px-2'>
                        <label htmlFor="First Name" className="block text-900 font-medium mb-2">District</label>
                        <Dropdown value={selectedDistrict}
                          onChange={(e) => {
                            setSelectedDistrict(e.value);
                          }}
                          options={districts}
                          optionLabel="name"
                          placeholder=" Select District "
                          showClear
                          className="w-full"
                        />
                    </div>
                    
                      <div className='w-4 pl-4' >
                        <label htmlFor="Email" className="block text-900 font-medium mb-2">TIN</label>
                        <InputText
                          className='w-full'
                          type="text"
                          placeholder="Enter TIN"
                          value={tin}
                          onChange={(e) => setTin(e.target.value)}
                        />
                      </div>
                  </div>
                  
                  <div className='flex justify-content-between mb-4 w-full'>
                    
                    <div className='w-4 pr-4' >
                        <label htmlFor="Email" className="block text-900 font-medium mb-2">Phone</label>
                        <InputText
                          className='w-full'
                          type="text"
                          placeholder="Enter Phone"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                    </div>
                    <div className='w-4 px-2' ></div>
                    <div className='w-4 pl-4' ></div>

                  </div>

                
                <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setFirstName(""); setLastName("") }} className="p-button-text p-2 px-3 mr-2" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="p-2 px-3"/>
                </div>
            </form>


              </Panel>
             
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8'  visible={editDialogVisible} style={{ width: '50vw' }} onHide={() => setEditDialogVisible(false)} >
            <Panel header="Edit User"> 
            <form onSubmit={(e) => { 
                e.preventDefault();
                    editUser(
                      selectedId,
                      editedFirstName,
                      setEditedFirstName,
                      editedLastName,
                      setEditedLastName,
                      editedSelectedRole,
                      setEditedSelectedRole,
                      editedPhone,
                      setEditedPhone,
                      editedSelectedSex,
                      setEditedSelectedSex,
                      editedSelectedRegion,
                      setEditedSelectedRegion,
                      editedSelectedDistrict,
                      setEditedSelectedDistrict,
                      editedTin,
                      setEditedTin,
                      setFetcherror,
                      handleAllToasts,
                      setUsers,
                      setIsLoading,
                      setFirst,
                      setRows,
                      undefined,
                      setTotalCount
                      
                    );
                setEditDialogVisible(false); 
              }}>
                  <div className='flex justify-content-between mb-4 w-full'>
                      <div className='w-4 pr-4' >
                        <label htmlFor="First Name" className="block text-900 font-medium mb-2">First Name</label>
                        <InputText
                          className='w-full'
                          type="text"
                          placeholder="Enter First Name"
                          value={editedFirstName}
                          onChange={(e) => setEditedFirstName(e.target.value)}
                        />
                      </div>

                      <div className='w-4 px-2'>
                        <label htmlFor="First Name" className="block text-900 font-medium mb-2">Last Name</label>
                        <InputText
                          className='w-full'
                          type="text"
                          placeholder="Enter Last Name"
                          value={editedLastName}
                          onChange={(e) => setEditedLastName(e.target.value)}
                        />
                    </div>
                    
                    <div className='w-4 pl-4'>
                      <label htmlFor="sex" className="block text-900 font-medium mb-2">Sex</label>
                      <Dropdown
                        value={editedSelectedSex}
                        onChange={(e) => setEditedSelectedSex(e.value)}
                        options={[{ id: 1, name: "MALE" }, { id: 2, name: "FEMALE" }]} optionLabel="name"
                        placeholder=" Select Sex " showClear className="w-full"
                        
                      /> 
                    </div>
                  </div>
                  
                  
                  <div className='flex justify-content-between mb-4 w-full'>

                      <div className='w-4 pr-4' >
                        <label htmlFor="Email" className="block text-900 font-medium mb-2">TIN</label>
                        <InputText
                          className='w-full'
                          type="text"
                          placeholder="Enter TIN"
                          value={editedTin}
                          onChange={(e) => setEditedTin(e.target.value)}
                        />
                      </div>

                      <div className='w-4 px-2' >
                        <label htmlFor="Email" className="block text-900 font-medium mb-2">Phone</label>
                        <InputText
                          className='w-full'
                          type="text"
                          placeholder="Enter Phone"
                          value={editedPhone}
                          onChange={(e) => setEditedPhone(e.target.value)}
                        />
                    </div>

                      <div className='w-4 pl-4'>
                        <label htmlFor="selectedrole" className="block text-900 font-medium mb-2">Role</label>
                          <Dropdown
                          value={editedSelectedRole} onChange={(e) => setEditedSelectedRole(e.value)}
                          options={roles} optionLabel="name"
                          placeholder="-- Select Role --" showClear className="w-full"
                          />
                      </div>
                  </div>
                  
                  <div className='flex justify-content-between mb-4 w-full'>
                
                      <div className='w-4 pr-4' >
                        <label htmlFor="region" className="block text-900 font-medium mb-2">Region</label>
                        <Dropdown
                          value={editedSelectedRegion}
                          onChange={(e) => {
                            setEditedSelectedRegion(e.value);
                            getRegionDistricts(setDistricts, setFetcherror, e.value?.id);
                          }}
                          options={regions}
                          optionLabel="name"
                          placeholder=" Select Region "
                          showClear
                          className="w-full"
                        />
                      </div>

                      <div className='w-4 px-2'>
                        <label htmlFor="First Name" className="block text-900 font-medium mb-2">District</label>
                        <Dropdown value={editedSelectedDistrict}
                          onChange={(e) => {
                            setEditedSelectedDistrict(e.value);
                          }}
                          options={districts}
                          optionLabel="name"
                          placeholder=" Select District "
                          showClear
                          className="w-full"
                        />
                    </div>
                    <div className='w-4 pl-4' ></div>
                      
                  </div>

                
                <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setFirstName(""); setLastName("") }} className="p-button-text p-2 px-3" />
                  <Button type='submit' label="Save" icon="pi pi-save"  autoFocus  className="p-2 px-3"/>
                </div>
                  </form>
                  </Panel> 
          </Dialog>
         </div>
        
        }

        {changePasswordDialogVisible && 
          
          <>
          <div className="card flex justify-content-center">
            <Dialog className='-mt-8' visible={changePasswordDialogVisible} style={{ width: '30vw' }} onHide={() => { setChangePasswordDialogVisible(false); setEditedPassword(""); }} >
            <Panel header="Change Password"> 
            <form onSubmit={(e) => { 
                e.preventDefault();
                changePassword (
                  selectedId,
                  editedPassword,
                  setEditedPassword,
                  setUsers,
                  setIsLoading,setFirst,setRows,setTotalCount,
                  setFetcherror,
                  handleAllToasts)
                setEditDialogVisible(false); 
              }}>
            <div className='w-full mb-4'>
              <label htmlFor="password" className="block text-900 font-medium mb-2">Password</label>
              <Password
                className={passwordClass}
                toggleMask
                feedback={false}
                placeholder='Enter Password'
                value={editedPassword}
                onChange={(e) => setEditedPassword(e.target.value)}
                onFocus={() => setPasswordInvalid("")}
                />
                  </div>
                  
                <div  className="card flex justify-content-end">
                  <Button type='submit' label="Save" icon="pi pi-save"  autoFocus  className="p-2 px-3"/>
                </div>
                  


                </form>
              </Panel>
            </Dialog>
            </div>
        </>
        }

        

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setUsers, setFetcherror, handleAllToasts,setIsLoading,setFirst,setRows,setTotalCount)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default Users